import React from 'react';
const HospitalResults = () => (
    <div style={{ padding: '4rem 0', textAlign: 'center', color: '#999' }}>
        <p style={{ fontSize: '1.6rem', fontWeight: 600 }}>성모병원</p>
        <p style={{ fontSize: '1.4rem', marginTop: '0.8rem' }}>준비중입니다.</p>
    </div>
);
export default HospitalResults;